import React, { useEffect, useState } from "react";

interface ScrollProgressProps {
  containerRef?: React.RefObject<HTMLElement>;
}

const ScrollProgress: React.FC<ScrollProgressProps> = ({ containerRef }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const target = containerRef?.current || document.documentElement;

      const scrollTop = containerRef?.current
        ? target.scrollTop
        : window.scrollY || document.documentElement.scrollTop;

      const scrollHeight = target.scrollHeight - target.clientHeight;

      if (scrollHeight > 0) {
        const scrollPercent = (scrollTop / scrollHeight) * 100;
        setProgress(Math.min(100, Math.max(0, scrollPercent)));
      }
    };

    const scrollTarget = containerRef?.current || window;
    scrollTarget.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Initial calculation

    return () => {
      scrollTarget.removeEventListener("scroll", handleScroll);
    };
  }, [containerRef]);

  // Don't show if at top
  if (progress < 1) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-0.5 bg-transparent">
      <div
        className="h-full bg-gradient-to-r from-[#22d3ee] to-[#06b6d4] transition-all duration-150 ease-out"
        style={{
          width: `${progress}%`,
          boxShadow: "0 0 8px rgba(34, 211, 238, 0.5)",
        }}
      />
    </div>
  );
};

export default ScrollProgress;
